<template>
    <div class="main">
        <a-row class="container" :gutter="0">
            <a-col :span="20" style="padding-bottom: 10px;" ref="search">
                <a-row>
                    <a-col span="6">
                        <a-input-search
                                placeholder="请输入关键字"
                                @search="onSearch"
                                enterButton
                        />
                    </a-col>
                    <a-col :span="14" style="margin-left: 20px;">
                        <a-button type="primary" @click="addReport">添加</a-button>
                    </a-col>
                </a-row>
            </a-col>
            <a-divider style="margin: 0;margin-bottom: 10px;"/>
            <a-col :span="24">
                <a-spin tip="加载中..." :spinning="spinning">
                    <div
                            class="demo-infinite-container"
                            v-infinite-scroll="handleInfiniteOnLoad"
                            :infinite-scroll-disabled="busy"
                            :infinite-scroll-distance="10"
                            :style="{height: listsHeight + 'px'}"
                    >
                        <a-list :dataSource="articleLists">
                            <a-list-item slot="renderItem" slot-scope="item, index" >
                                <a slot="actions" @click.stop="chooseItem(item.id, item.title)" v-if="isSelectingReportAction"><a-icon type="check-square" theme="twoTone" twoToneColor="#1890ff" v-if="choosedReportId === item.id"/><a-icon type="border" v-else/></a>
                                <a-list-item-meta description="宣传指令"  @click="toAddArticle(item.id)">
                                    <a slot="title">{{item.title}}</a>
                                    <a-avatar slot="avatar" icon="file-text" style="backgroundColor: #1890ff"/>
                                </a-list-item-meta>
                                <div class="desc">{{item.addtime}}<br>{{item.reporter}}</div>
                            </a-list-item>
                            <div v-if="loading && !busy" class="demo-loading-container">
                                <a-spin />
                            </div>
                        </a-list>
                    </div>
                </a-spin>
            </a-col>
        </a-row>
        <footer-tool-bar v-show="isSelectingReportAction">
            <a-button type="primary" @click="goBack">确定选择</a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import infiniteScroll from 'vue-infinite-scroll'
    import FooterToolBar from '../../components/FooterToolBar'
    import ACol from "ant-design-vue/es/grid/Col";
    const nums = 20
    export default {
        name: "ReportList",
        components:{
            ACol,
            FooterToolBar
        },
        directives: { infiniteScroll },
        data () {
            return {
                userInfo: '',
                page: 1,
                searchValue: '',
                articleLists: [],
                loading: false,
                busy: false,
                spinning: true,
                listsHeight: 0,
                channelListObject: {},
                choosedReportId: '',
                choosedReportName: '',
                currentIndex: 0,
                footerBarHeight: 0,
                isSelectingReportAction: false
            }
        },
        methods: {
            chooseItem (id, name) {
                this.currentIndex = parseInt(id)
                this.choosedReportName = name
                this.choosedReportId = id
            },
            getChannelObject (chanelLists) {
                for (var i in chanelLists) {
                    this.channelListObject[chanelLists[i].id] = chanelLists[i].name
                }
            },
            // 获取报题渠道
            getChannel () {
                this.$http.post('api/report/channel')
                    .then((res) => {
                        if (res.data.state === 200) {
                            this.getChannelObject(res.data.data)
                            this.$store.commit('storeChanelList', res.data.data)
                        } else {
                        }
                    })
                    .catch(() => {
                        this.isShowModal = false
                    })
            },
            getList () {
                this.busy = true
                this.$http.post('api/report/lists', { page: this.page, title: this.searchValue, channel_id: 1})
                    .then((res) => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        if (res.data.state === 200) {
                            if (res.data.data.length > 0) {
                                this.articleLists.push.apply(this.articleLists, res.data.data)
                                if (this.articleLists.length < nums) {
                                    this.busy = true
                                }
                            } else {
                                this.page--
                            }
                        } else {
                            this.page--
                        }
                    })
                    .catch(() => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        this.page--
                    })
            },
            handleInfiniteOnLoad  () {
                this.loading = true
                if (this.articleLists.length < nums) {
                    this.loading = false
                    this.busy = true
                    return
                }
                if (!this.busy) {
                    this.page++
                    this.getList()
                }
            },
            goBack () {
                if (this.choosedReportId && this.choosedReportName) {
                    this.$store.commit('storeChoosedReportInfo', {id: this.choosedReportId, name: this.choosedReportName})
                } else { // 排除未选择时 返回不改变全局变量
                }
                this.$router.go(-1)
            },
            toAddArticle (_id) {
                this.$router.push({path: '/Main/Direct/AddDirect', query: {id: _id}})
            },
            onSearch (value) {
                if (!this.spinning) {
                    this.searchValue = value
                    this.loading = false
                    this.busy = false
                    this.spinning = true
                    this.articleLists = []
                    this.page = 1
                    this.getList()
                }
            },
            addReport () {
                this.$router.push('/Main/Direct/AddDirect')
            }
        },
        created() {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted() {
            // this.isSelectingReportAction = this.$store.state.isSelectingReportAction
            // if (this.isSelectingReportAction) {
            //     this.footerBarHeight = 56
            // }
            this.listsHeight = window.innerHeight - 92 - 40 - this.footerBarHeight - this.$refs.search.$el.clientHeight - 11// 92为顶部导航高度 地址栏高度、 40 margin距离、footerBarHeight 56 底部悬浮按钮高度 11 分割线高度
            // if (this.$store.state.channelList.length === 0) {
            //     this.getChannel()
            // } else {
            //     this.getChannelObject(this.$store.state.channelList)
            // }
            this.getList()
        },
        // beforeRouteEnter (to, from, next) {
        //     next(vm => {
        //     })
        // },
        // beforeRouteLeave (to, from, next) {
        //     if (from.path.indexOf('ReportList') > -1 && to.path.indexOf('AddTag') > -1) {
        //         this.$store.commit('storeIsSelectingReportAction', false)
        //     }
        //     next()
        // }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 10px;
        padding-right: 20px;
    }
    .demo-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 0px 24px;
        overflow-x: hidden;
    }
    .demo-loading-container {
        position: absolute;
        bottom: 40px;
        width: 100%;
        text-align: center;
    }
    .desc{
        line-height: 22px;
    }
    .ant-list-item-meta{
        cursor: pointer;
    }
    .ant-list-item >>> .ant-list-item-content{
        flex: none;
    }
</style>
